type FlagType = 'Enable' | 'Experiment' | 'Release';

export const SpadeFeatureFlags = {
  SpadeReleaseSdk: 'Spade_Release_Sdk',
  SpadeReleaseEmbedCashGames: 'Spade_Release_EmbedCashGames',
  SpadeReleaseEmbedHomeGames: 'Spade_Release_EmbedHomeGames',
  SpadeReleaseEmbedPokerTable: 'Spade_Release_EmbedPokerTable',
  SpadeReleaseEmbedPowerPath: 'Spade_Release_EmbedPowerPath',
  SpadeReleaseEmbedSpinAndGo: 'Spade_Release_EmbedSpinAndGo',
  SpadeReleaseEmbedTournamentTickets: 'Spade_Release_EmbedTournamentTickets',
  SpadeEnableAnalytics: 'Spade_Enable_Analytics'
} satisfies Record<`Spade${FlagType}${string}`, `Spade_${FlagType}_${string}`>;
